'use client';

import AuthPageSkeleton from '@/components/auth/AuthPageSkeleton';

export default function AuthSigninLoading() {
  return <AuthPageSkeleton titleWidth="w-56" descriptionLines={3} />;
}
